import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Position, Toaster, Intent } from '@blueprintjs/core';

class ToastHandler extends Component {
    componentWillReceiveProps(nextProps) {
        const toast = nextProps.toast;
        if (toast) {
            this.toaster.clear();
            const { intent } = toast;
            let intentType, iconType;
            switch (intent) {
                case 'error':
                    intentType = Intent.DANGER;
                    iconType = 'warning-sign';
                    break;
                case 'welcome':
                    intentType = Intent.PRIMARY;
                    iconType = 'hand'
                    break;
                case 'info':
                case 'loader':
                    intentType = Intent.NONE;
                    iconType = intent === 'loader' ? 'time': 'info-sign';
                    break;
                case 'success':
                default:
                    intentType = Intent.SUCCESS;
                    iconType = 'tick';
                    break;
            }
            toast.intent = intentType;
            toast.icon = iconType;
            this.toaster.show(toast);
        }
    }

    refHandlers = {
        toaster: el => (this.toaster = el),
    };

    render() {
        return (
            <Toaster position={ Position.TOP_CENTER } ref={this.refHandlers.toaster} />
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    toast: state.toast.toast,
});
const ToastHandlerContainer = connect(
    mapStateToProps,
    {}
)(ToastHandler);

export default ToastHandlerContainer;


// WEBPACK FOOTER //
// ./src/components/widgets/ToastHandler.jsx